<div class="row mb-10">
  <div *ngFor="let item of dataHistoryHeader.value" class="col-lg-6">
    <app-card>
      <div cardBody class="p-3 d-flex align-items-center">
        <span class="svg-icon svg-icon-desc" inlineSVG="{{item.icon}}"></span>
        <h1 class="mb-0">{{item.value}} <span>{{item.label}}</span></h1>
      </div>
    </app-card>
  </div>
</div>

<app-card>
  <ng-container cardHeader>
    <h1>History Scan</h1>
  </ng-container>

  <ng-container cardBody>
    <ng-container *ngIf="baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseBlock"
                  cardBody>
      <app-card-empty icon="{{iconNone}}" text="Belum terdapat data reward."></app-card-empty>
    </ng-container>

    <ng-template #elseBlock>
      <div class="table-responsive">
        <table
          (matSortChange)="sortTable($event)"
          [dataSource]="baseDatasource"
          class="table w-100 gy-5 table-row-bordered align-middle"
          mat-table
          matSort
        >
          <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
            <ng-container *ngIf="tableColumn.isSortable; else notSortable">
              <th
                *matHeaderCellDef
                [arrowPosition]="'after'"
                [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                [mat-sort-header]="tableColumn.key"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                  {{tableColumn.title}}
                </div>
                <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                  <app-table-content></app-table-content>
                </div>
              </th>
            </ng-container>
            <ng-template #notSortable>
              <th
                *matHeaderCellDef
                [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                [ngClass]="{
                  'min-w-70px text-center': tableColumn.key === 'actions',
                  'w-250px': tableColumn.key === 'alamat'
                }"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                  {{tableColumn.title}}
                </div>
                <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                  <app-table-content
                    [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"></app-table-content>
                </div>
              </th>
            </ng-template>
            <td *matCellDef="let element" class="px-3" mat-cell>
              <ng-container [ngSwitch]="tableColumn.key">
                <div *ngSwitchCase="'action'">
                  <button class="btn btn-table-actions-download is-download"
                  >
                  <span
                    (click)="handleAction()"
                    [inlineSVG]="'./assets/media/icons/ic_task.svg'"

                    class="svg-icon svg-icon-2 cursor-pointer"
                  ></span>
                  </button>
                </div>
                <div *ngSwitchDefault>
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                    <span>{{ element[tableColumn.key] }} </span>
                  </app-table-content>
                </div>
              </ng-container>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>
        <div class="d-flex justify-content-between py-4">
          <!--        <app-mai-material-bottom-table-->
          <!--          class="w-100"-->
          <!--          [baseDataTableComponent]="baseDatasource"-->
          <!--          (changePage)="changePageEvent($event)"-->
          <!--        ></app-mai-material-bottom-table>-->
        </div>
      </div>
    </ng-template>
  </ng-container>
</app-card>
